const mutations = {};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/white-label/mutations.js